import { z } from 'zod';

export const Z_ID = z
  .coerce
  .number();